import { useAuth } from "@/contexts/AuthProvider";

interface DynamicInstitutionNameProps {
  className?: string;
  fallbackName?: string;
}

const DynamicInstitutionName = ({
  className,
  fallbackName = "Plataforma SDT",
}: DynamicInstitutionNameProps) => {
  const { authenticated, initialized, appConfig, configLoaded } = useAuth();

  // Si no está autenticado, no inicializado, o no se ha cargado la config, mostrar fallback
  if (!authenticated || !initialized || !configLoaded) {
    return <p className={className}>{fallbackName}</p>;
  }

  // Si tenemos nombre dinámico, mostrarlo
  return (
    <p className={className}>{appConfig?.institution_name || fallbackName}</p>
  );
};

export default DynamicInstitutionName;
